import { memo } from "react";

import { SkillInfo } from "./skillsSlice";

import "./Skills.css";

export const SkillIcon = () => (
  <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M9 1L3 9h4.5L7 15l6-8H8.5L9 1Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

// Chips azules del área de texto: la skill elegida en el menú "/"
// (pendiente de enviarse) y las que el bot reporta activas en esta
// conversación. La × la quita: si ya estaba activa, el siguiente
// mensaje le pide al bot que la apague (channelData.dropSkills).
function SkillChips(props: {
  pending: SkillInfo | null;
  active: SkillInfo[];
  onRemove: (skill: SkillInfo, wasActive: boolean) => void;
}) {
  const chips = [
    ...(props.pending ? [{ skill: props.pending, isActive: false }] : []),
    ...props.active
      .filter((skill) => skill.name !== props.pending?.name)
      .map((skill) => ({ skill, isActive: true })),
  ];
  if (!chips.length) return null;

  return (
    <div className="skill-chips">
      {chips.map(({ skill, isActive }) => (
        <span
          key={skill.name}
          className={isActive ? "skill-chip" : "skill-chip skill-chip--pending"}
          title={
            isActive
              ? `${skill.title}: active in this conversation`
              : `${skill.title}: starts with your next message`
          }
        >
          <SkillIcon />
          <span className="skill-chip__command">{skill.command}</span>
          <span className="skill-chip__title">{skill.title}</span>
          <button
            type="button"
            className="skill-chip__remove"
            aria-label={`Turn off ${skill.title}`}
            onClick={() => props.onRemove(skill, isActive)}
          >
            ×
          </button>
        </span>
      ))}
    </div>
  );
}

export default memo(SkillChips);
